import { render, staticRenderFns } from "./Contentbar.vue?vue&type=template&id=67acf230&scoped=true&"
import script from "./Contentbar.vue?vue&type=script&lang=js&"
export * from "./Contentbar.vue?vue&type=script&lang=js&"
import style0 from "./Contentbar.vue?vue&type=style&index=0&id=67acf230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67acf230",
  null
  
)

export default component.exports